module.exports = __webpack_public_path__ + "img/76.c0244fb9.jpg";